import SearchBar from "src/components/common/SearchBar";
import OrderTypeFilterButtons from "src/components/common/OrderTypeFilterButtons";
import { ActiveOrdersHeaderProps } from "../../../interfaces/active-orders-props.interface";

const ActiveOrdersHeader = ({
  searchOrders,
  orderTypeFilter,
  onOrderTypeFilter,
}: ActiveOrdersHeaderProps) => {
  return (
    <div className="flex justify-between items-center flex-wrap gap-3">
      <SearchBar placeholder="Search Orders..." onChange={searchOrders} />
      <OrderTypeFilterButtons value={orderTypeFilter} onChange={onOrderTypeFilter} />
    </div>
  );
};

export default ActiveOrdersHeader;
